import { render, staticRenderFns } from "./grpcenter.vue?vue&type=template&id=95ae1f92&"
import script from "./grpcenter.vue?vue&type=script&lang=js&"
export * from "./grpcenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports